import { useI18n } from "../../lib/i18n";
import { LANGS } from "../../lib/translations";

export default function LanguageSwitcher({ variant = "nav" }) {
    const { lang, setLang } = useI18n();
    const isNav = variant === "nav";
    return (
        <div
            className={`inline-flex items-center gap-1 rounded-full border border-white/10 bg-white/[0.03] ${isNav ? "p-1" : "p-1.5"}`}
            data-testid="language-switcher"
            role="group"
            aria-label="Language switcher"
        >
            {LANGS.map((code) => {
                const active = lang === code;
                return (
                    <button
                        key={code}
                        onClick={() => setLang(code)}
                        data-testid={`lang-btn-${code}`}
                        aria-pressed={active}
                        className={`font-mono uppercase tracking-[0.16em] transition-all duration-300 rounded-full ${
                            isNav
                                ? "text-[10px] px-2.5 py-1"
                                : "text-[11px] px-3 py-1.5"
                        } ${
                            active
                                ? "bg-[#E55B13] text-black"
                                : "text-white/60 hover:text-white"
                        }`}
                    >
                        {code === "en" ? "EN" : "GR"}
                    </button>
                );
            })}
        </div>
    );
}
